export default __webpack_public_path__ + "static/image-github-search-a2f6691573b9f32e1df97aecc28ae7c6.png";